module.exports = __webpack_public_path__ + "img/stop.29648b38.svg";